import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=7ed9c34b&"
import script from "./Acciones.vue?vue&type=script&lang=ts&"
export * from "./Acciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7ed9c34b', component.options)
    } else {
      api.reload('7ed9c34b', component.options)
    }
    module.hot.accept("./Acciones.vue?vue&type=template&id=7ed9c34b&", function () {
      api.rerender('7ed9c34b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administracion/Acciones.vue"
export default component.exports